// Homepage account destinations. Preserve the application's existing role-specific routes.
const STAFF_WORKSPACES = {
  FDC: "/administration/workspace/fdc",
  SDD: "/administration/sdd-workspace",
  ED: "/administration/executive/director-teritory",
  CEO: "/executive_officer/workspaces",
};

export const CLIENT_SIGN_IN = "/access/client-portal/authentication/sign-in";
export const STAFF_SIGN_IN = "/administration/staff-login";

export function getPublicAccount(state) {
  const staffSession = state?.universeStaffs;
  const staff = staffSession?.activeStaff || {};
  const roleValue = staff?.role?.name || staff?.role?.code || staff?.role || "";
  const staffRole = typeof roleValue === "string" ? roleValue.toUpperCase().trim() : "";
  // Do not infer staff authentication from a stale profile; the reducer is authoritative.
  if (staffSession?.isAuthenticated && STAFF_WORKSPACES[staffRole]) {
    const person = staff.personalInfo || {};
    const name = person.fullName || [person.firstName, person.lastName || person.surname].filter(Boolean).join(" ") || staff.name || staff.staffId || staffRole;
    const workspace = STAFF_WORKSPACES[staffRole];
    const param = staffRole === "ED" ? "view" : "page";
    const section = (page) => staffRole === "CEO" ? workspace : `${workspace}?${param}=${page}`;
    return {
      type: "staff", role: staffRole, name, image: person.profileImage || staff.profileImage || "",
      staffId: staff.staffId || staff.employeeId || person.staffId || "",
      workspace, profile: staffRole === "CEO" ? null : section("profile"),
      notifications: staffRole === "CEO" ? null : section("notifications"),
      settings: staffRole === "CEO" ? null : section("settings"),
    };
  }
  const clientSession = state?.clientFunction;
  if (clientSession?.isAuthenticated) {
    const client = clientSession?.companiesDB?.clientData?.clientInfo || clientSession?.companiesDB?.clientData || clientSession?.queue?.clientData?.clientInfo || {};
    const person = client?.owner?.personalInfo || client?.personalInfo || {};
    const clientId = client?._id || client?.clientId || clientSession?.companiesDB?.clientData?.clientId || "";
    const workspace = clientId ? `/advance-companies-management-system/company-account?notation=${encodeURIComponent(clientId)}` : "/cloud-profile-account/client-account";
    return {
      type: "client", role: "Client", name: [person.firstName, person.lastName].filter(Boolean).join(" ") || client.companyName || "My account",
      image: client?.owner?.files?.profilImage || "", workspace, profile: "/cloud-profile-account/client-account",
      notifications: null, settings: null, staffId: "",
    };
  }
  return { type: "visitor", name: "Visitor", role: "", image: "", workspace: null, profile: null, notifications: null, settings: null, staffId: "" };
}

export const PUBLIC_NAV_THEME_KEY = "universe_public_nav_theme";
export const PUBLIC_NAV_THEME_EVENT = "universe:public-navigation-theme";
export function readPublicNavTheme() {
  try { return window.localStorage.getItem(PUBLIC_NAV_THEME_KEY) === "dark" ? "dark" : "light"; }
  catch { return "light"; }
}
export function savePublicNavTheme(theme) {
  const value = theme === "dark" ? "dark" : "light";
  try { window.localStorage.setItem(PUBLIC_NAV_THEME_KEY, value); } catch { /* optional device preference */ }
  window.dispatchEvent(new CustomEvent(PUBLIC_NAV_THEME_EVENT, { detail: value }));
}
